import React from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import {
    archiveChatSession,
    unarchiveChatSession,
} from 'flow/actions/channels-actions';
import ContextMenu from 'flow/components/ContextMenu';
import MenuItem from 'flow/components/ui-components/MenuItem';
import useAppContext from 'flow/hooks/useAppContext';
import { ChatSession } from 'flow/types/Chats';
import { ChannelKey } from 'flow/types/EntityKeys';
import { TypedMap } from 'flow/types/TypedMap';
import { getMoreOptionsLabel } from 'flow/utils/a11y-utils';

interface Props {
    channelKey: ChannelKey;
    chatSession: TypedMap<ChatSession>;
    setActive: (isActive: boolean) => void;
}

const LiveChatContextMenu = ({ channelKey, chatSession, setActive }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    return (
        <ContextMenu
            triggerLabel={getMoreOptionsLabel(i18next, chatSession.get('name'))}
            setActive={setActive}
            lockScroll={{
                scroll: document.querySelector('#live-chat-page'),
                wrapper: document.querySelector('#live-chat-page'),
            }}
        >
            {chatSession.get('chatArchived') ? (
                <MenuItem
                    onClick={() =>
                        dispatch(
                            unarchiveChatSession(
                                channelKey,
                                chatSession.get('key'),
                            ),
                        )
                    }
                >
                    {i18next.t('Channel.OpenClose.Label.Open')}
                </MenuItem>
            ) : (
                <MenuItem
                    onClick={() =>
                        dispatch(
                            archiveChatSession(
                                channelKey,
                                chatSession.get('key'),
                            ),
                        )
                    }
                >
                    {i18next.t('Channel.OpenClose.Label.Close')}
                </MenuItem>
            )}
        </ContextMenu>
    );
};

export default LiveChatContextMenu;
